import { FC } from 'react';

import { StyledGrid } from './styles';
import { Props } from './types';

const FormFieldsContainer: FC<Props> = ({
  className,
  columns = 1,
  children,
}) => {
  return (
    <StyledGrid className={className} container spacing={2} columns={columns}>
      {children}
    </StyledGrid>
  );
};

export default FormFieldsContainer;
